<div class="example-container" [class.example-is-mobile]="mobileQuery.matches" *ngIf="shouldRun">
  <mat-nav-list>
    <ng-container *ngFor="let item of menuItems.getMenuitem()">
      <!-- Parent Items without Children -->
      <ng-container *ngIf="!item.childMenu || item.childMenu.length === 0">
        <mat-list-item [routerLink]="item.state" >
          <div fxLayout="row" fxLayoutAlign="start center"  (click)="onOnlyItemClick(item)"
            style="padding-top: 10px; color: #ADADAD; font-size: 15px; font-weight: normal; text-align: left; line-height: 20px;">

            <img *ngIf="item.imageUrl" [src]="item.imageUrl" [matTooltip]="item.name" alt="Image"
              style="width: 17px; height: 17px;">

              

            <mat-label style="padding-left: 8px; vertical-align: middle; padding-top: 4px;" *ngIf="!sidenavOpened" [class.selected]="isSelected(item)">{{
              item.name}}</mat-label>
          </div>

        </mat-list-item>
      </ng-container>

      <!-- Parent Items with Children -->
      <!-- <ng-container *ngIf="item.childMenu && item.childMenu.length > 0">
        <div style="display: flex; align-items: center; cursor: pointer; padding-left: 15px; padding-top: 10px;"
          (click)="item.expanded = !item.expanded" fxLayout="row" fxLayoutAlign="space-between center">
          <div style="display: flex; align-items: center;">
            <img [src]="item.imageUrl" alt="EDI Image" style="width: 20px; height: 20px; margin-right: 8px;" [matTooltip]="item.name">
            <mat-label *ngIf="!sidenavOpened"
              [class.parent-selected]="parentItem === item"
              style="padding-top: 10px; color: #ADADAD; font-size: 13px; font-weight: normal; text-align: left; line-height: 20px;">
              {{item.name}}
            </mat-label>
          </div>
        </div>
        <mat-list *ngIf="item.expanded">
          <mat-list-item *ngFor="let child of item.childMenu" [routerLink]="child.state" style="height: 30px;">
            <div fxLayout="row" fxLayoutAlign="start center"
              style="padding-top: 0px; color: #ADADAD; font-size: 13px;
              font-weight: normal; text-align: left; line-height: 20px;">
              <mat-label style="padding-left: 0px; vertical-align: middle; padding-top: 0px;"
                (mouseover)="child.isHovered = true" (mouseout)="child.isHovered = false"
                [class.hovered]="child.isHovered" (click)="onMenuItemClick(child, item)"
                [class.selected]="selectedItem === child" *ngIf="!sidenavOpened">{{ child.name }}
              </mat-label>
            </div>
          </mat-list-item>
        </mat-list>
      </ng-container> -->
    <ng-container *ngIf="item.childMenu && item.childMenu.length > 0">
      <div style="display: flex; align-items: center; cursor: pointer; padding-left: 15px; padding-top: 10px;"
        (click)="toggleExpansion(item)" fxLayout="row" fxLayoutAlign="space-between center"
        [class.selected-parent]="isParentSelected(item)">
        <div style="display: flex; align-items: center;">
          <img [src]="item.imageUrl" alt="EDI Image" style="width: 17px; height: 17px; margin-right: 8px;"
            [matTooltip]="item.name">
          <span *ngIf="sidenavOpened" style="height: 35px;"> </span>
          <mat-label *ngIf="!sidenavOpened"
            [ngClass]="{'parent-selected': parentItem === item, 'parent-not-selected': parentItem !== item}"
            (mouseover)="item.isHovered = true" (mouseout)="item.isHovered = false"
                 [class.hovered]="item.isHovered"
            style="padding-top: 10px; padding-bottom: 5px; font-size: 15px; font-weight: normal; text-align: left; line-height: 20px;">
            {{ item.name }}
          </mat-label>
        </div>
        
            <!-- Expand/collapse icon -->
            <button mat-icon-button value="sidebarclosed" color="#F59120" style="padding-left: 10px;color: #F59120;">
              <mat-icon class="parent-expand-icon">{{ item.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>
      </div>
    
      <!-- Child Menu -->
      <mat-list *ngIf="item.expanded">
        <ng-container *ngFor="let child of item.childMenu">
    
          <div *ngIf="child.subChildMenu && child.subChildMenu.length === 0" >
            <mat-list-item [routerLink]="child.state" 
              (click)="onMenuItemClick(child, item)" style="height: 30px;">
              <div fxLayout="row" fxLayoutAlign="start center"
                style="padding-top: 0px; color: #ADADAD; font-size: 15px; font-weight: normal; text-align: left; line-height: 20px; padding-left:24px;">
                <mat-label style="padding-left: 0px; vertical-align: middle; padding-top: 0px;"
                  (mouseover)="child.isHovered = true" (mouseout)="child.isHovered = false"
                  [class.selected]="isSelected(child)"
                  [class.hovered]="child.isHovered" *ngIf="!sidenavOpened">
                  {{ child.name }}
                </mat-label>
              </div>
            </mat-list-item>
    
          </div>
    




          <div *ngIf="child.subChildMenu && child.subChildMenu.length > 0">
            <mat-list-item [class.selected]="isSelected(child)" (click)="toggleExpansionChild(child)"
              style="height: 30px;">
              <div fxLayout="row" fxLayoutAlign="space-between center"
                style="padding-top: 0px; color: #ADADAD; font-size: 15px; font-weight: normal; text-align: left; line-height: 20px; padding-left:24px;">
                <mat-label style="padding-left: 0px; vertical-align: middle; padding-top: 0px;"
                  (mouseover)="child.isHovered = true" (mouseout)="child.isHovered = false"
                  [class.hovered]="child.isHovered" *ngIf="!sidenavOpened">
                  {{ child.name }}
                </mat-label>

                 <!-- Expand/collapse icon -->
            <button mat-icon-button value="sidebarclosed" color="#F59120" style="padding-left: 10px;color: #F59120; font-size: 16px;">
              <mat-icon class="child-expand-icon">{{ child.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>
              </div>
            </mat-list-item>
    
            <!-- Sub-child Menu: should NOT be inside the mat-list-item -->
            <mat-list *ngIf="child.subChildMenu && child.subChildMenu.length > 0 && child.expanded">
              <mat-list-item *ngFor="let subChild of child.subChildMenu" [routerLink]="subChild.state"
                (click)="onSubChildMenuClick($event, subChild, child, item)" style="height: 30px;">
                <div fxLayout="row" fxLayoutAlign="start center"
                  style="padding-top: 0px; color: #ADADAD; font-size: 15px; font-weight: normal; text-align: left; line-height: 20px; padding-left:48px;">
                  <mat-label style="padding-left: 0px; vertical-align: middle; padding-top: 0px;"
                    (mouseover)="subChild.isHovered = true" (mouseout)="subChild.isHovered = false"
                    [ngClass]="{'selected': isSubChildSelected(subChild)}"
                    [class.hovered]="subChild.isHovered" *ngIf="!sidenavOpened">
                    {{ subChild.name }}
                  </mat-label>
                </div>
              </mat-list-item>
            </mat-list>
          </div>
        </ng-container>
      </mat-list>
    </ng-container>

    </ng-container>
  </mat-nav-list>
</div>
